class WishlistNotification extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.handleShowToastNotification =
      this.handleShowToastNotification.bind(this)

    this.handleClose = this.handleClose.bind(this)
    this.handleStartCloseFunction = this.handleStartCloseFunction.bind(this)
    this.handleStopCloseFunction = this.handleStopCloseFunction.bind(this)

    this.handleShowToastNotification()

    this.listeners.add(this.els.close.element, 'click', this.handleClose)
    this.listeners.add(this, 'mouseover', this.handleStopCloseFunction)
    this.listeners.add(this, 'mouseout', this.handleStartCloseFunction)
  }

  handleShowToastNotification () {
    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      window._swat.evtLayer.addEventListener(
        window._swat.JSEvents.addedToWishlist,
        (data) => {
          const productTitle = data.detail.d.dt
          const productImage = data.detail.d.iu

          const listConfig = {
            lid: data.detail.d.lid,
          }

          const onSuccess = (listDetails) => {
            this.els.media.element.innerHTML = productImage
              ? `<div class="rsp-Image"><img class="rsp-Image_Image" src="${productImage}" alt="${productTitle}"></div>`
              : ''
            this.els.title.element.innerHTML = `<strong>${productTitle}</strong> has been added to your wishlist successfully.`
          }

          const onError = (error) => {
            this.handleClose()

            /* eslint-disable-next-line no-console */
            console.log('Error while fetching List details', error)
          }

          window._swat.fetchListDetails(listConfig, onSuccess, onError)

          setTimeout(() => {
            this.setAttribute('aria-hidden', 'false')

            this.handleStartCloseFunction()
          }, 1000)
        },
      )
    })
  }

  handleClose () {
    this.classList.remove('wsh-Notification-active', 'wsh-Notification-paused')
    this.animationHook = false
    this.setAttribute('aria-hidden', 'true')
  }

  handleStartCloseFunction () {
    this.classList.add('wsh-Notification-active')
    this.classList.remove('wsh-Notification-paused')

    if (!this.animationHook) {
      this.animationHook = true

      this.addEventListener(
        'animationend',
        (event) => {
          if (event.animationName === 'toast-progress') this.handleClose()
        },
        { once: true },
      )
    }
  }

  handleStopCloseFunction () {
    this.classList.add('wsh-Notification-paused')
  }
}

if (!customElements.get('wishlist-notification')) {
  customElements.define('wishlist-notification', WishlistNotification)
}
